import request from "../Utils/Request";

export function updateData(url: string, data: any) {
  return request.patch(url, data);
}
